import { Injectable } from '@angular/core';
import { Expression, Model_VariableEnvironnementUser, EXPRESSION_FIELD_SCOPE, Model_WorkflowComponent } from 'src/app/app.models';
import { EventWorkflowValuesChanged } from '../workflow-components.service';
import { DatasourceService } from 'src/app/core-api/services/datasource/datasource.service';

@Injectable()
export class ExpressionBuilderService {
    constructor(
        private _datasourceService: DatasourceService
    ) {
    }
    
    doCheckIfExpressionContainsField(_expression: Expression, _fieldname: string) {
        const rules = this.doFlatConditionRules(_expression);
        return rules.findIndex(r => r.field !== undefined && r.field == _fieldname) > -1;
    }

    doFlatConditionRules(_condition: Expression) {
        let rules: Expression[] = [];
        _condition.rules.forEach(rule => {
            if (rule.rules !== undefined) {
                rules = rules.concat(this.doFlatConditionRules(rule));
            } else {
                rules.push(rule);
            }
        })
        return rules;
    }

    async doBuildExpression(_expression: Expression, _options: ExpressionBuilderOption): Promise<boolean> {
        let result = _options.initialState;
        if (_expression.rules !== undefined) {
            for (var r in _expression.rules) {
                const rule = _expression.rules[r];
                if (rule.rules !== undefined) {
                    const buildedExpression = await this.doBuildExpression(rule, _options);
                    result = _expression.condition == 'and' ? result && buildedExpression : result || buildedExpression;
                } else if (rule.operator !== undefined) {
                    let buildedExpression = _options.initialState;
                    if (rule.scope == EXPRESSION_FIELD_SCOPE.CONSTANT) {
                        switch(rule.operator) {
                            case 'eq':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && String(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) == String(rule.value);
                                break;

                            case 'neq':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && String(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) != String(rule.value);
                                break;

                            case 'gte':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) >= parseInt(rule.value);
                                break;

                            case 'gt':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) > parseInt(rule.value);
                                break;

                            case 'lte':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) <= parseInt(rule.value);
                                break;

                            case 'lt':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) < parseInt(rule.value);
                                break;

                            case 'isnull':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] == null;
                                break;

                            case 'isnotnull':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] != null;
                                break;
                        }
                    } else if (rule.scope == EXPRESSION_FIELD_SCOPE.WORKFLOW_COMPONENT) {
                        switch(rule.operator) {
                            case 'eq':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value] !== undefined && String(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) == String(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value]);
                                break;

                            case 'neq':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value] !== undefined && String(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) != String(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value]);
                                break;

                            case 'gte':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value] !== undefined &&parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) >= parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value]);
                                break;

                            case 'gt':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value] !== undefined && parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) > parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value]);
                                break;

                            case 'lte':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value] !== undefined && parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) <= parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value]);
                                break;

                            case 'lt':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value] !== undefined && parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) < parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.value]);
                                break;

                            case 'isnull':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] == null;
                                break;

                            case 'isnotnull':
                                buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] != null;
                                break;
                        }
                    } else if (rule.scope == EXPRESSION_FIELD_SCOPE.VARIABLE_ENVIRONNEMENT) {
                        const variableEnvironment = _options.environmentVariables.find(v => v.NOM_VARIABLE == rule.value);
                        if (variableEnvironment !== undefined) {
                            switch(rule.operator) {
                                case 'eq':
                                    buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && String(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) == String(variableEnvironment.VALEUR_VARIABLE);
                                    break;
    
                                case 'neq':
                                    buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && String(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) != String(variableEnvironment.VALEUR_VARIABLE);
                                    break;
    
                                case 'gte':
                                    buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) >= parseInt(variableEnvironment.VALEUR_VARIABLE);
                                    break;
    
                                case 'gt':
                                    buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) > parseInt(variableEnvironment.VALEUR_VARIABLE);
                                    break;
    
                                case 'lte':
                                    buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) <= parseInt(variableEnvironment.VALEUR_VARIABLE);
                                    break;
    
                                case 'lt':
                                    buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && parseInt(_options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) < parseInt(variableEnvironment.VALEUR_VARIABLE);
                                    break;
    
                                case 'isnull':
                                    buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] == null;
                                    break;
    
                                case 'isnotnull':
                                    buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] != null;
                                    break;
                            }
                        }
                    } else if (rule.scope == EXPRESSION_FIELD_SCOPE.DATASOURCE) {
                        const datasource = await this._datasourceService.doLoadDatasource(rule.value);
                        if (datasource !== undefined) {
                            const datasourceColumn = datasource.DS_PARAMS.DS_COLUMNS.find(c => c.name == rule.datasource_column);
                            if (datasourceColumn !== undefined) {
                                switch(rule.operator) {
                                    case 'in_datasource':
                                        buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && datasource.datas.mPagination.mDatas.findIndex(d => d[datasourceColumn.name] !== undefined && d[datasourceColumn.name] == _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) > -1;
                                        break;
        
                                    case 'not_in_datasource':
                                        buildedExpression = !!_options.eventWorkflowValuesChanged.formValues && !!_options.eventWorkflowValuesChanged.formValues[_options.formGroupId] && _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field] !== undefined && datasource.datas.mPagination.mDatas.findIndex(d => d[datasourceColumn.name] !== undefined && d[datasourceColumn.name] == _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field]) == -1;
                                        break;
                                }
                            }
                        }
                    } else if (rule.scope == EXPRESSION_FIELD_SCOPE.WORKFLOW_COMPONENT_METADATA) {
                        if (_options.eventWorkflowValuesChanged.workflow !== undefined && _options.eventWorkflowValuesChanged.formModels[_options.formGroupId] !== undefined) {
                            const workflowComponents = Array.prototype.concat.apply([], _options.eventWorkflowValuesChanged.workflow.WORKFLOW_STEPS.filter(step => !!step.COMPONENTS).map(step => step.COMPONENTS));

                            const propertyValue = _options.eventWorkflowValuesChanged.formValues[_options.formGroupId][rule.field];
                            const workflowComponent = workflowComponents.find(c => c.ID == propertyValue);
                            if (workflowComponent !== undefined) {
                                switch(rule.operator) {
                                    case 'eq':
                                        buildedExpression = String(workflowComponent[rule.datasource_column]) == String(rule.value);
                                        break;

                                    case 'neq':
                                        buildedExpression = String(workflowComponent[rule.datasource_column]) != String(rule.value);
                                        break;
                                }
                            } else {
                                buildedExpression = false;
                            }
                        }
                    }
                    result = _expression.condition == 'and' ? result && buildedExpression : result || buildedExpression;
                }
            }
        }
        return result;
    }

    async doGetErrorExpression(_expression: Expression) {
        let error = '';
        if (_expression.rules !== undefined) {
            for (var r in _expression.rules) {
                const rule = _expression.rules[r];
                if (rule.rules !== undefined) {
                    const buildedExpression = await this.doGetErrorExpression(rule);
                    error += (_expression.condition == 'and' ? 'ET ' : 'OU ') + buildedExpression;
                } else if (rule.operator !== undefined) {
                    if (rule.scope == EXPRESSION_FIELD_SCOPE.CONSTANT) {
                        switch(rule.operator) {
                            case 'eq':
                                error += `${rule.field} doit etre égal à '${rule.value}' `;
                                break;

                            case 'neq':
                                error += `${rule.field} doit etre différent de '${rule.value}' `;
                                break;

                            case 'gte':
                                error += `${rule.field} doit etre supérieur ou égal à '${rule.value}' `;
                                break;

                            case 'gt':
                                error += `${rule.field} doit etre supérieur à '${rule.value}' `;
                                break;

                            case 'lte':
                                error += `${rule.field} doit etre inférieur ou égal à '${rule.value}' `;
                                break;

                            case 'lt':
                                error += `${rule.field} doit etre inférieur à '${rule.value}' `;
                                break;

                            case 'isnull':
                                error += `${rule.field} doit etre NULL `;
                                break;

                            case 'isnotnull':
                                error += `${rule.field} ne doit pas etre NULL `;
                                break;
                        }
                    } else if (rule.scope == EXPRESSION_FIELD_SCOPE.WORKFLOW_COMPONENT) {
                        switch(rule.operator) {
                            case 'eq':
                                error += `${rule.field} doit etre égal au champ @[${rule.value}] `;
                                break;

                            case 'neq':
                                error += `${rule.field} doit etre différent du champ @[${rule.value}] `;
                                break;

                            case 'gte':
                                error += `${rule.field} doit etre supérieur ou égal au champ @[${rule.value}] `;
                                break;

                            case 'gt':
                                error += `${rule.field} doit etre supérieur au champ @[${rule.value}] `;
                                break;

                            case 'lte':
                                error += `${rule.field} doit etre inférieur ou égal au champ @[${rule.value}] `;
                                break;

                            case 'lt':
                                error += `${rule.field} doit etre inférieur au champ @[${rule.value}] `;
                                break;

                            case 'isnull':
                                error += `${rule.field} doit etre NULL `;
                                break;

                            case 'isnotnull':
                                error += `${rule.field} ne doit pas etre NULL `;
                                break;
                        }
                    } else if (rule.scope == EXPRESSION_FIELD_SCOPE.VARIABLE_ENVIRONNEMENT) {
                        switch(rule.operator) {
                            case 'eq':
                                error += `${rule.field} doit etre égal à la variable d'environnement #[${rule.value}] `;
                                break;

                            case 'neq':
                                error += `${rule.field} doit etre différent de la variable d'environnement #[${rule.value}] `;
                                break;

                            case 'gte':
                                error += `${rule.field} doit etre supérieur ou égal à la variable d'environnement #[${rule.value}] `;
                                break;

                            case 'gt':
                                error += `${rule.field} doit etre supérieur à la variable d'environnement #[${rule.value}] `;
                                break;

                            case 'lte':
                                error += `${rule.field} doit etre inférieur ou égal à la variable d'environnement #[${rule.value}] `;
                                break;

                            case 'lt':
                                error += `${rule.field} doit etre inférieur à la variable d'environnement #[${rule.value}] `;
                                break;

                            case 'isnull':
                                error += `${rule.field} doit etre NULL `;
                                break;

                            case 'isnotnull':
                                error += `${rule.field} ne doit pas etre NULL `;
                                break;
                        }
                    } else if (rule.scope == EXPRESSION_FIELD_SCOPE.DATASOURCE) {
                        const datasource = await this._datasourceService.doLoadDatasource(rule.value);
                        const datasourceColumn = datasource.DS_PARAMS.DS_COLUMNS.find(c => c.name == rule.datasource_column);
                        if (datasource !== undefined && datasourceColumn !== undefined) {
                            switch(rule.operator) {
                                case 'in_datasource':
                                    error += `la valeur saisie doit être contenu dans la colonne [${datasourceColumn.name}] de la source de données ${datasource.TITRE} `;
                                    break;
    
                                case 'not_in_datasource':
                                    error += `la valeur saisie ne doit pas être contenu dans la colonne [${datasourceColumn.name}] de la source de données ${datasource.TITRE} `;
                                    break;
                            }
                        }
                    }
                }
            };
        }
        return error;
    }
}

export class ExpressionBuilderOption {
    eventWorkflowValuesChanged: EventWorkflowValuesChanged; 
    environmentVariables: Model_VariableEnvironnementUser[]; 
    initialState: boolean;
    formGroupId: string;
    fieldComponent?: Model_WorkflowComponent;
}